import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

import { BillToParty } from '../../../enums/bill-to-party';
import { ShippingAccountColumnContainer } from '../../../containers/shipping-account-column-container';

const ShippingAccountColumn = ({ fulfillmentPlanId }) => {
  const { labelConfiguration } = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }));

  const { sellerLabelProviderId, options } = labelConfiguration ?? {};

  if (!sellerLabelProviderId) {
    return '';
  }

  return (
    <ShippingAccountColumnContainer
      billToAccount={options?.billToAccount?.accountNumber}
      billToParty={BillToParty.find((party) => party === options?.billToAccount?.billToParty)}
      shippingProviderId={sellerLabelProviderId}
    />
  );
};

ShippingAccountColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const ShippingAccount = {
  getMessageDescriptor: () => messages.shippingAccount,
  id: 'shippingAccount',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return '';
    }
    return <ShippingAccountColumn fulfillmentPlanId={data.id} />;
  },
};
